import { AuthPopup } from "../components/_shared/AuthPopup";
import { FooterDemo } from "../components/_shared/FooterDemo";
import { FooterSocialMediaLine } from "../components/_shared/FooterSocialMediaLine";
import { Header } from "../components/_shared/Header";
import { Navbar } from "../components/_shared/Navbar";
import { ContactUsHeroImg } from "../components/contactUs/content/layout/ContactUsHeroImg";
import { ContactUsMainContainer } from "../components/contactUs/content/layout/ContactUsMainContainer";

export const ContactUs = () => {
  return (
    <div
      style={{
        width: "100%",
        display: "flex",
        alignItems: "center",
        flexDirection: "column",
      }}
    >
      <>
        <div className="portfolio-header-sticky-wrapper">
          <div
            style={{
              backgroundColor: "rgba(255, 255, 255, 1)",
            }}
          >
            <Header>
              <Navbar />
            </Header>
          </div>
        </div>
        <ContactUsHeroImg />
        <ContactUsMainContainer />
        <FooterDemo />
        <FooterSocialMediaLine />
        <AuthPopup />
      </>
    </div>
  );
};
